import { syncURLParams } from "./searchHelpers";
import currencyRanges from "./currencyRanges.json";

export const applyFilterURL = (state) => {
  const searchParams = new URLSearchParams(window.location.search);
  if (state.filters.budgets) {
    const currentBudgets = state.filters.budgets.split(",");
    const rangeInSelectedCurrency =
      currencyRanges[state.currency.code].resort.filterRange;

    const results = [];
    currentBudgets.forEach((_b) => {
      results.push(rangeInSelectedCurrency[_b][0]);
    });

    searchParams.set("budgets", results.join(","));
  } else {
    searchParams.delete("budgets");
  }

  if (state.filters.destinations) {
    searchParams.set("destinations", state.filters.destinations);
  } else {
    searchParams.delete("destinations");
  }

  if (state.filters.greenfin) {
    searchParams.set("greenfin", 1);
  } else {
    searchParams.delete("greenfin");
  }

  if (state.filters.rating) {
    searchParams.set("rating", state.filters.rating);
  } else {
    searchParams.delete("rating");
  }

  if (state.filters.facilities) {
    searchParams.set("facilities", state.filters.facilities);
  } else {
    searchParams.delete("facilities");
  }

  if (state.filters.species) {
    searchParams.set("species", state.filters.species);
  } else {
    searchParams.delete("species");
  }

  if (state.filters.tags) {
    searchParams.set("goodFor", state.filters.tags);
  } else {
    searchParams.delete("goodFor");
  }

  syncURLParams(searchParams);
};

export const getPrimaryDestinationFilters = () => {
  if (window.zubluDestination.type === "destination") {
    return [
      `__platform_destination_id:${window.zubluDestination.id}`,
      `__platform_searchable_destination_ids:${window.zubluDestination.id}`,
    ];
  } else if (window.zubluDestination.type === "province") {
    return [
      `__platform_region_id:${window.zubluDestination.id}`,
      `__platform_searchable_destination_ids:${window.zubluDestination.id}`,
    ];
  } else if (window.zubluDestination.type === "country") {
    return [
      `__platform_country_id:${window.zubluDestination.id}`,
      `__platform_searchable_destination_ids:${window.zubluDestination.id}`,
    ];
  }
};

export const getSecondaryDestinationFilters = (filters) => {
  if (filters.destinations) {
    return filters.destinations
      .split(",")
      .map((destinationId) => `__platform_destination_id:${destinationId}`);
  }

  return null;
};

export const getBudgetFilters = (filters) => {
  const filteringBudgets = filters.budgets.split(",").filter((x) => x);

  const selectedCurrency = window.topNavStore.state.currency;
  const rangeInSelectedCurrency =
    currencyRanges[selectedCurrency.code].resort.filterRange;
  const rate = window.zubluCurrencyTable[selectedCurrency.code];

  if (filteringBudgets.length === 0) {
    return "__odyssey_price > 0";
  }

  let numericFilters = [];

  if (filteringBudgets.includes("0")) {
    numericFilters.push(
      `__odyssey_price:${rangeInSelectedCurrency[0][0] *
        rate} TO ${rangeInSelectedCurrency[0][1] * rate}`
    );
  }
  if (filteringBudgets.includes("50")) {
    numericFilters.push(
      `__odyssey_price:${rangeInSelectedCurrency[50][0] *
        rate} TO ${rangeInSelectedCurrency[50][1] * rate}`
    );
  }
  if (filteringBudgets.includes("100")) {
    numericFilters.push(
      `__odyssey_price:${rangeInSelectedCurrency[100][0] *
        rate} TO ${rangeInSelectedCurrency[100][1] * rate}`
    );
  }
  if (filteringBudgets.includes("250")) {
    numericFilters.push(
      `__odyssey_price:${rangeInSelectedCurrency[250][0] *
        rate} TO ${rangeInSelectedCurrency[250][1] * rate}`
    );
  }
  if (filteringBudgets.includes("500")) {
    numericFilters.push(
      `__odyssey_price > ${rangeInSelectedCurrency[500][0] * rate}`
    );
  }

  return [numericFilters];
};

export const getConservationFilters = (filters) => {
  const hasGreenfinFilter = filters.greenfin === "1";

  if (hasGreenfinFilter) {
    return "__odyssey_greenfins_member:true";
  } else {
    return null;
  }
};

export const getRatingFilters = (filters) => {
  const filteringRating = filters.rating.split(",").filter((x) => x);

  if (filteringRating.length === 0) {
    return null;
  }

  let list = [];
  if (filteringRating.includes("excellent")) {
    list.push("__platform_rating:5");
  }
  if (filteringRating.includes("very_good")) {
    list.push("__platform_rating:4");
  }
  if (filteringRating.includes("average")) {
    list.push("__platform_rating:3");
  }
  if (filteringRating.includes("poor")) {
    list.push("__platform_rating:1 TO 2");
  }
  if (filteringRating.includes("unrated")) {
    list.push("__platform_rating:0");
  }

  return list;
};
